<template>
  <section class="bg-white">
    <HeaderBackground :backgroundPath="`/${$staticPath}/${data.headerImg}`"></HeaderBackground>
    <div class="container">
      <div class="newsId">
        <div class="header">
          <h1>{{data.header}}</h1>
        </div>
        <div class="content">
          <div class="time-type">
            <div class="time">
              <i class="fa fa-clock-o" aria-hidden="true" style="color: #FFA500;"></i><span> {{data.time}}</span>
            </div>
            <div class="type">
              <i class="fa fa-tag" aria-hidden="true" style="color: #FFA500;"></i><span> {{data.type}}</span>
            </div>
          </div>
          <div class="header-img">
            <img :src="`/${$staticPath}/${data.headerImg}`" class="w-75">
          </div>
          <div class="detail">
            <div v-for="(item, index) in data.fullDetail" v-html="item" :key="index"></div>
          </div>
          <div class="img-other text-center">
            <img v-for="(img, index) in data.imgSet" :src="img" :key="index">
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import HeaderBackground from '../COMMON/HeaderBackground.vue'
import news from '../../json/news/news.js'

export default {
  components: {
    HeaderBackground
  },
  data () {
    return {
      data: {}
    }
  },
  created () {
    this.data = news.getNews(this.$route.params.newsId)
  }
}
</script>

<style scoped>
  .cover {
    min-height: 75vh;
    background-size: cover;
    background-attachment: fixed;
    background-color: #FFF;
    background-position: center;
  }

  .newsId {
    padding: 60px 0;
  }

  .header h1 {
    color: #FFA500;
    font-weight: 300;
    font-size: 32px;
  }

  .newsId .time-type .time, .newsId .time-type .type {
    display: inline-block;
    padding-right: 30px;
    margin-bottom: 30px;
  }

  .newsId .time-type span, .newsId .time-type i{
    font-size: 18px;
  }

  .newsId .header-img {
    text-align: center;
    margin-bottom: 30px;
  }

  .detail {
    margin-bottom: 30px;
  }

  .detail > div {
    margin-bottom: 10px;
  }

  .img-other img{
    margin-bottom: 30px;
  }

  @media screen and (max-width: 768px) {
    .newsId .header h1 {
      font-size: 33px;
    }

    .newsId .time-type span, .newsId .time-type i{
      font-size: 16px;
    }

    #newsId img {
      width: 100% !important;
    }

    .detail p {
      text-indent: 0em;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/NewsId/Index.vue